import React from 'react';
import ActivateIcon from '@/assets/svg/activate.svg';
import DeactivateIcon from '@/assets/svg/deactivate.svg';

export const SubscriptionStatusSwitchIcon: React.FC<{
  isActivating: boolean;
}> = ({ isActivating }) => {
  const Icon = isActivating ? ActivateIcon : DeactivateIcon;
  return <Icon />;
};

export const SubscriptionPlanStatusDescription: React.FC<{
  planName: string;
  isActivating: boolean;
}> = ({ planName, isActivating }) => {
  const prefix = isActivating
    ? 'Czy na pewno chcesz aktywować plan subskrypcji '
    : 'Czy na pewno chcesz dezaktywować plan subskrypcji ';

  return (
    <div className="flex flex-col justify-center items-center">
      <span>{prefix}</span>
      <span
        className="font-medium break-words"
        style={{
          fontFamily: 'Roboto, sans-serif',
          fontWeight: 500,
          overflowWrap: 'break-word',
          wordBreak: 'break-word',
        }}
      >
        {planName}?
      </span>
    </div>
  );
};
